import { BrandKit } from '@goldcast/api/backend';

import { PlatformBrandKitState } from './types';
import { extractFontsFromBrandKits } from './utils';

import { loadFontList } from '@/utils/fonts';

const mutations = {
  async setBrandKit(state: PlatformBrandKitState, payload: { brandKit: BrandKit[] }) {
    if (payload.brandKit.length) {
      state.isLoaded = true;
      state.brandKits = payload.brandKit;
      loadFontList(extractFontsFromBrandKits(payload.brandKit));
    } else {
      state.isLoaded = true;
      state.brandKits = [];
    }
  }
};

export type BrandKitMutations = typeof mutations;

export default mutations;
